// En src/utils/adsense.js
export const loadAdSense = () => {
  if (typeof window !== 'undefined' && !document.querySelector('script[src*="adsbygoogle"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1510186530311664';
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }
};
